<template>
    <v-app>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <eps-login-header></eps-login-header> -->
        <v-content>
            <!-- <v-container class="fill-height" flemail> -->
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense>
                            <v-col cols="12" sm="3" md="2">
                                <v-img class="schl-logo" :src="org_basic_data.trust_logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8">
                                <!-- <center>
                  <h2>{{ org_name }}</h2>
                </center>
                {{ org_basic_data }} -->
                                <center>
                                    <h3 class="trust-name">{{ org_basic_data.trust_name }}</h3>
                                    <h1 class="schl-name">{{ org_basic_data.school_name }}</h1>
                                    <span class="adrs">{{ org_basic_data.address }}</span><br />
                                    <span class="adrs"> Ph.No. {{ org_basic_data.phone }} </span>
                                    <span style="margin-left: 5px;"> Email: {{ org_basic_data.email }} </span><br />
                                    <span class="line1" v-html="org_basic_data.line1"></span><br />

                                    <span class="line2" v-html="org_basic_data.line2"></span>
                                </center>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-img class="schl-logo" :src="org_basic_data.school_logo" />
                            </v-col>
                        </v-row>
                        <v-toolbar class="toolbar" dense flat>
                            <v-toolbar-title>Pay Admission Fee</v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>

                        <v-row dense>
                            <v-col cols="12" sm="1" md="1"></v-col>
                            <v-col sm="4" md="3" cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay" return-object label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"></v-autocomplete>
                            </v-col>
                            <v-col sm="2" md="3" cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"></v-autocomplete>
                            </v-col>
                            <v-col sm="2" md="3" cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-text-field dense outlined rounded v-model="form_no" persistent-hint label="Application Form No."></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pt-3 mt-3">
                                <v-btn class="button" v-if="ay && std && form_no" @click="getFeeDeatils()">Get Fee Details</v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-if="application_fee_list != ''" justify="center" dense>
                            <v-col sm="6" md="6" cols="12">
                                <v-text-field dense outlined required :rules="[rules.required]" rounded v-model.trim="application_form_stud_name" persistent-hint label="Enter Student Name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="application_fee_list != ''" justify="center" dense>
                            <!-- <v-col sm="2" md="2" cols="12" class="pt-1 mt-1">
                  <v-text-field
                    dense
                    outlined
                    rounded
                    v-model="application_form_stud_name"
                    persistent-hint
                    label="Enter Student Name"
                  ></v-text-field>
                </v-col> -->
                            <v-col cols="12" sm="2" md="2" class="pt-1 mt-1">
                                <v-text-field dense outlined rounded v-model="application_fee_list[0].fee" readonly filled persistent-hint label="Admission Fee"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pt-1 mt-1">
                                <v-text-field dense outlined rounded  v-model="application_fee_list[0].start_date" readonly filled persistent-hint label="Admission Start Date"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pt-1 mt-1">
                                <v-text-field dense outlined rounded v-model="application_fee_list[0].end_date" readonly filled persistent-hint label="Admission End Date"></v-text-field>
                            </v-col>
                            <!-- {{application_form_stud_name}} -->

                            <!-- <v-col cols="12" sm="2" md="2" >
                                        <v-btn class="button"  @click="payAdmissionFee()">Pay Fee</v-btn>
                                    </v-col> -->
                        </v-row>
                        <v-row dense justify="center">
                            <form :action="url" v-if="pg_hidden != null" @submit="payAdmissionFee" name="paytmform" method="POST">
                                <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                                <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                                <input type="hidden" :value="application_form_stud_name" name="uid" />
                                <input type="hidden" :value="pg_hidden.studid" name="studid" />
                                <input type="hidden" :value="pg_hidden.ay" name="ay" />
                                <input type="hidden" :value="pg_hidden.fee_amount" name="fee_amount" />
                                <input type="hidden" :value="pg_hidden.purpose" name="purpose" />
                                <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                                <input type="hidden" :value="pg_hidden.std_id" name="std_id" />
                                <v-btn
                                    class="button1"
                                    :loading="pg_loader"
                                    v-if="
                    application_fee_list != '' &&
                    pay_flag == false &&
                   application_form_stud_name != null && application_form_stud_name != ''
                  "
                                    type="submit"
                                >
                                    Pay Online
                                </v-btn>
                            </form>
                        </v-row>
                        <!-- {{application_form_list}} -->
                        <v-toolbar class="toolbar" dense flat v-if="application_form_list != ''">
                            <v-toolbar-title>Payment Transactions</v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <br />
                        <v-data-table v-if="application_form_list != ''" :headers="headers" :items="application_form_list" class="elevation-1 mytable" dense :search="search">
                            <template v-slot:item.is_fees_paid="{ item }">
                                <span v-if="item.is_fees_paid">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
            <!-- </v-container> -->
        </v-content>

        <eps-login-footer></eps-login-footer>
    </v-app>
</template>

<script>
    import axios from "axios";
    import epsLoginHeader from "./LoginHeader.vue";
    import epsLoginFooter from "./LoginFooter.vue";
    export default {
        components: {
            epsLoginHeader: epsLoginHeader,
            epsLoginFooter: epsLoginFooter,
        },
        data() {
            return {
                message: "",
                dns: null,
                ay_list: [],
                ay: null,
                standard_list: [],
                std: null,
                org_id: null,
                org_name: null,
                org_basic_data: null,
                form_no: null,
                application_form_list: [],
                pay_flag: null,
                application_fee_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                application_form_stud_name: null,
                pg_hidden: [],
                pg_loader: false,
                flag:true,
                url: null,
                rules: {
                    required: (value) => !!value || "Required Please Enter Name.",
                    },
                headers: [
                    {
                        text: "Sr. No.",
                        align: "left",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Application From No.",
                        align: "left",
                        sortable: false,
                        value: "form_no",
                    },
                    {
                        text: "Student Name",
                        align: "left",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Amount",
                        align: "left",
                        sortable: false,
                        value: "fee",
                    },
                    {
                        text: "Paid for Standard",
                        align: "left",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Order Id",
                        align: "left",
                        sortable: true,
                        value: "order_id",
                    },
                    {
                        text: "Transaction Id",
                        align: "left",
                        sortable: true,
                        value: "trxn_id",
                    },
                    {
                        text: "Transaction Date",
                        value: "transaction_date",
                        sortable: false,
                    },
                    {
                        text: "Payment Status",
                        value: "transaction_status",
                        sortable: false,
                    },
                ],
            };
        },
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_admission";
        },
        methods: {
            validName() {
                this.validMob();
                if (/[^a-zA-Z\s]/.test(this.visitor_name)) {
                    this.error = "Input value contains other syantax.";
                    this.showSnackbar("red", "Input value contains other syantax.");
                    // alert("Input value contains other syantax");
                } else {
                  
                }
                },
            payAdmissionFee() {
                var formData = new FormData(paytmform);
                this.pg_loader = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getFeeDeatils() {
                const data = {
                    ay: this.ay.id,
                    std: this.std,
                    form_no: this.form_no,
                    dns: this.dns,
                    org_id: this.org_id,
                };
                axios
                    .post("/Admission/getFeeDeatils", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.application_form_list = res.data.application_form_list;
                            this.pay_flag = res.data.pay_flag;
                            this.application_fee_list = res.data.application_fee_list;
                            this.application_form_stud_name = res.data.application_form_stud_name;
                            this.pg_hidden = res.data.pg_hidden;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            onload() {
                const data = {
                    dns: this.dns,
                };
                axios
                    .post("/Admission/getOrgList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay_list = res.data.ay_list;
                            this.standard_list = res.data.standard_list;
                            this.org_name = res.data.org_name;
                            this.org_basic_data = res.data.org_basic_data;
                            this.org_id = res.data.org_id;
                            this.ay = res.data.admission_current;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.dns = window.location.hostname;
            // alert(this.dns);
            this.onload();
        },
    };
</script>
<style scoped>
    .pull-right {
        position: relative;
        text-align: center;
    }
    .app {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .schl-logo {
        width: 70%;
    }
    .button1 {
        border: 2px solid white !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
        background-color: lightgray !important;
    }
    .button1:hover {
        color: white !important;
        background: #0d96e3 !important;
        background: #0d96e3;
        /* background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
  background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
    }
</style>
